import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderSharingNewReject = (data) => openPopupHelper({ popupName: popupNames.REJECT_DIALOG, data });
